
    const html = "<div class=modal-header> <button type=button class=close aria-label=Close ng-click=$dismiss()> <span aria-hidden=true>&times;</span> </button> <h4 class=modal-title>Rules</h4> </div> <div class=modal-body> <rules-text></rules-text> </div> <div class=modal-footer> <button class=\"btn btn-primary\" ng-click=$dismiss()>Got it!</button> </div> ";
    angular.module('ng').run(['$templateCache', function($templateCache){
      $templateCache.put('/modules/users/views/authentication/rules-modal.client.view.html', html);
    }]);
    module.exports = '/modules/users/views/authentication/rules-modal.client.view.html';
  